import { render, staticRenderFns } from "./ForgotPasswordResetContainer.vue?vue&type=template&id=ae503012&"
import script from "./ForgotPasswordResetContainer.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordResetContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports